import React, { FC } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart, Bar
} from "recharts";
import { ProjectResponse } from '@api/projects/mutations';
import { formatValue } from '@components/create-project/table/helpers';
import { CircularProgress } from '@mui/material';
import { useTranslation } from "react-i18next";

interface OfferGraphProps {
  offer: ProjectResponse | null;
}

export const RelativeComparisonGraph: FC<OfferGraphProps> = ({ offer }) => {
  const { t } = useTranslation();

  if (!offer) return <CircularProgress size={100}/>;

  const case1Data = offer.outputs['Offer to customer']['Financial Information to Building Owner']['Case 1'];
  const case2Data = offer.outputs['Offer to customer']['Financial Information to Building Owner']['Case 2'];
  const case3Data = offer.outputs['Offer to customer']['Financial Information to Building Owner']['Case 3'];

  const data = [
    {
      name: "Case 1",
      "Total Price rel.": case1Data["Total Price rel."],
      "BKZ rel.": case1Data["BKZ rel."],
    },
    {
      name: "Case 2",
      "Total Price rel.": case2Data["Total Price rel."],
      "BKZ rel.": case2Data["BKZ rel."],
    },
    {
      name: "Case 3",
      "Total Price rel.": case3Data["Total Price rel."],
      "BKZ rel.": case3Data["BKZ rel."],
    }
  ];

  return (
    <ResponsiveContainer className="print:hidden" width="100%" style={{ paddingTop: '34px' }} height={500}>
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis tickFormatter={(value) => `${value}`} />
        <Tooltip formatter={(value: number, name: string) => [`${formatValue(value)} EUR`, name]} />
        <Legend />
        <Bar dataKey="Total Price rel." name="Total Price rel." fill="#9DD4D9" />
        <Bar dataKey="BKZ rel." name="BKZ rel." fill="#D5EA64" />
        <text
          x="50%"
          y={8}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: '14px', fill: '#18181B', fontWeight: 500 }}
        >
          {t('project.table.financialCalculation.graphTitle')}
        </text>
      </BarChart>
    </ResponsiveContainer>
  );
};
